module.exports = __webpack_public_path__ + "static/media/chelsea.71ad94ff.jpg";